import React from 'react';
import shortid from 'shortid';

const Radio = props => {
    const {selected, option, onChange, ...theRest} = props;
    const {text} = option;
    const id = shortid.generate();

    return (
        <div className="custom-control custom-radio custom-control-inline">
            <input
                {...theRest}
                className="custom-control-input"
                id={id}
                type="radio"
                onClick={() => onChange(!selected, option)} />
            <label className="custom-control-label" htmlFor={id}>
                <span>&nbsp;{text}</span>
            </label>
        </div>
    );
};

const SplitStyle = props => {
    const {options, selectedOptions, onChange} = props;
    const groupName = shortid.generate();

    const handleRadioClicked = option => {
        const {fullText: selectedOptionId} = option;

        if (!selectedOptions[selectedOptionId]){
            selectedOptions[selectedOptionId] = {};
        }

        onChange(selectedOptions, option);
    };

    const handleSubOptionsListChange = (subSelections, option) => {
        const {fullText: optionId} = option;
        selectedOptions[optionId] = subSelections;

        if (selectedOptions[optionId]) {
            onChange(selectedOptions, option);
        }
    };

    return (
        <ul className="splitStyle">
            {options.map((option, i) => {
                const {cn, leaf, fullText} = option;
                const selected = selectedOptions[fullText];

                return (
                    <li key={`${i}`}>
                        <Radio
                            name={`group-${groupName}`}
                            selected={selected}
                            option={option}
                            onChange={() => {handleRadioClicked(option);}} />
                        {(!leaf && cn && cn.length > 0 && selected) && (
                            <SplitStyle
                                options={cn}
                                selectedOptions={selected}
                                onChange={(subSelections, subOption) => handleSubOptionsListChange(subSelections, subOption)} />
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default SplitStyle;
